// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OldBrowserModal_modal__QOd1m {
  background-color: #F6F7F8;
  padding-left: 0;
  padding-right: 0;
  text-align: center;
}
@media (min-width: 576px) {
  .OldBrowserModal_modal__QOd1m {
    padding-left: 40px;
    padding-right: 40px;
  }
}
.OldBrowserModal_modal__QOd1m .modal__overlay, .OldBrowserModal_modal__QOd1m .modal__close-btn {
  display: none;
}
.OldBrowserModal_modal__QOd1m .modal__inner {
  max-width: 648px;
  position: static;
  background: none;
  border-radius: 24px;
}
@media (min-width: 576px) {
  .OldBrowserModal_modal__QOd1m .modal__inner {
    background-color: var(--white);
  }
}

.OldBrowserModal_header__legYu {
  position: absolute;
  left: 0;
  right: 0;
  top: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 1200px) {
  .OldBrowserModal_header__legYu {
    top: 22px;
  }
  .OldBrowserModal_header__legYu .OldBrowserModal_logo__hHXLd svg, .OldBrowserModal_header__legYu .OldBrowserModal_logo__hHXLd img {
    max-width: 150px;
    max-height: 150px;
  }
}
@media (max-width: 640px) {
  .OldBrowserModal_header__legYu .OldBrowserModal_logo__hHXLd svg,
  .OldBrowserModal_header__legYu .OldBrowserModal_logo__hHXLd img {
    max-width: 100px;
    max-height: 100px;
  }
}

.OldBrowserModal_logo__hHXLd svg, .OldBrowserModal_logo__hHXLd img {
  max-width: 200px;
  max-height: 120px;
  height: auto;
}

div.OldBrowserModal_lang__iZ62p {
  position: absolute;
  top: 0;
  right: 12px;
}
@media (min-width: 640px) {
  div.OldBrowserModal_lang__iZ62p {
    right: 30px;
  }
}

.OldBrowserModal_logoTxt__O1RI8 {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  color: var(--gray-500);
  display: flex;
}

.OldBrowserModal_title__n6Z2Y {
  margin-bottom: 8px;
}

.OldBrowserModal_txt__4ytHp {
  margin-bottom: 24px;
}

.OldBrowserModal_list__Pxemy {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  list-style-type: none;
  grid-gap: 16px;
  margin-bottom: 24px;
}
@media (min-width: 640px) {
  .OldBrowserModal_list__Pxemy {
    grid-template-columns: repeat(4, 1fr);
  }
}

.OldBrowserModal_item__9M1N1 {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-color: var(--white);
  border-radius: 12px;
  padding: 16px;
}
@media (min-width: 576px) {
  .OldBrowserModal_item__9M1N1 {
    background-color: var(--grey-25);
  }
}
.OldBrowserModal_item__9M1N1 img {
  max-width: 50px;
  margin-bottom: 10px;
}
@media (min-width: 640px) {
  .OldBrowserModal_item__9M1N1 img {
    max-width: 100%;
  }
}

.OldBrowserModal_itemTxt__NlU9F {
  display: block;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/OldBrowserModal/OldBrowserModal.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACF;AACE;EANF;IAOI,kBAAA;IACA,mBAAA;EAEF;AACF;AAEM;EAEE,aAAA;AADR;AAIM;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAFR;AAIQ;EANF;IAOI,8BAAA;EADR;AACF;;AAOA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJF;AAME;EATF;IAUI,SAAA;EAHF;EAMI;IACE,gBAAA;IACA,iBAAA;EAJN;AACF;AAQE;EAEI;;IAEE,gBAAA;IACA,iBAAA;EAPN;AACF;;AAaE;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;AAVJ;;AAcA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;AAXF;AAaE;EALF;IAMI,WAAA;EAVF;AACF;;AAaA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;EACA,aAAA;AAVF;;AAaA;EACE,kBAAA;AAVF;;AAaA;EACE,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,qCAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;AAVF;AAYE;EAPF;IAQI,qCAAA;EATF;AACF;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AATF;AAWE;EARF;IASI,gCAAA;EARF;AACF;AAUE;EACE,eAAA;EACA,mBAAA;AARJ;AAUI;EAJF;IAKI,eAAA;EAPJ;AACF;;AAWA;EACE,cAAA;EACA,WAAA;AARF","sourcesContent":[".modal {\r\n  background-color: #F6F7F8;\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n  text-align: center;\r\n\r\n  @media (min-width: 576px) {\r\n    padding-left: 40px;\r\n    padding-right: 40px;\r\n  }\r\n\r\n  :global {\r\n    .modal {\r\n      &__overlay,\r\n      &__close-btn {\r\n        display: none;\r\n      }\r\n\r\n      &__inner {\r\n        max-width: 648px;\r\n        position: static;\r\n        background: none;\r\n        border-radius: 24px;\r\n\r\n        @media (min-width: 576px) {\r\n          background-color: var(--white);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.header {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 42px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  @media (max-width: 1200px) {\r\n    top: 22px;\r\n\r\n    .logo {\r\n      svg, img {\r\n        max-width: 150px;\r\n        max-height: 150px;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 640px) {\r\n    .logo {\r\n      svg,\r\n      img {\r\n        max-width: 100px;\r\n        max-height: 100px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.logo {\r\n  svg, img {\r\n    max-width: 200px;\r\n    max-height: 120px;\r\n    height: auto;\r\n  }\r\n}\r\n\r\ndiv.lang {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 12px;\r\n\r\n  @media (min-width: 640px) {\r\n    right: 30px;\r\n  }\r\n}\r\n\r\n.logoTxt {\r\n  position: absolute;\r\n  bottom: 24px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  color: var(--gray-500);\r\n  display: flex;\r\n}\r\n\r\n.title {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.txt {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.list {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  list-style-type: none;\r\n  grid-gap: 16px;\r\n  margin-bottom: 24px;\r\n\r\n  @media (min-width: 640px) {\r\n    grid-template-columns: repeat(4, 1fr);\r\n  }\r\n}\r\n\r\n.item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n  background-color: var(--white);\r\n  border-radius: 12px;\r\n  padding: 16px;\r\n\r\n  @media (min-width: 576px) {\r\n    background-color: var(--grey-25);\r\n  }\r\n\r\n  img {\r\n    max-width: 50px;\r\n    margin-bottom: 10px;\r\n\r\n    @media (min-width: 640px) {\r\n      max-width: 100%;\r\n    }\r\n  }\r\n}\r\n\r\n.itemTxt {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `OldBrowserModal_modal__QOd1m`,
	"header": `OldBrowserModal_header__legYu`,
	"logo": `OldBrowserModal_logo__hHXLd`,
	"lang": `OldBrowserModal_lang__iZ62p`,
	"logoTxt": `OldBrowserModal_logoTxt__O1RI8`,
	"title": `OldBrowserModal_title__n6Z2Y`,
	"txt": `OldBrowserModal_txt__4ytHp`,
	"list": `OldBrowserModal_list__Pxemy`,
	"item": `OldBrowserModal_item__9M1N1`,
	"itemTxt": `OldBrowserModal_itemTxt__NlU9F`
};
export default ___CSS_LOADER_EXPORT___;
